// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"b0bff6cc","453":"f51d9dd1","796":"efd12714"}[chunkId] + ".chunk.js";
};